/**
 * @file Customization UI injection into parent page and API
 *
 * @supported Modern browsers only (no legacy IE support)
 */

import YETI from 'yeti';

/**
 * Initialize the widget iframe and customizer namespace properties
 *
 * @constructor
 */
function customizer() {

    /**
     * Will be set to true once all assets are loaded
     *
     * @type {boolean}
     */
    this.ready = false;

    /**
     * Build the iframe and load the Customizer with given options
     *
     * @param opts
     * @returns {*}
     */
    this.init = opts => {

        if (!opts.selector) {
            return YETI.error('No target selector defined');
        }

        const target = document.querySelector(opts.selector);

        if (!target) {
            return YETI.error('Target selector not found');
        }

        // Expose properties required for app consumption
        this.options = opts;
        this.targetSelector = opts.selector;
        this.iframeSelector = '[data-ycs="customizer"]';

        const iframe = document.querySelector(this.iframeSelector);

        if (iframe) {
            iframe.remove();
        }

        // Build iframe
        const iframeNew = document.createElement('iframe');
        const cssUrl = YETI.appHost + 'app.css?t=' + YETI.cacheBust;
        const jsUrl = YETI.appHost + 'app.min.js?t=' + YETI.cacheBust;
        const html = '<!doctype html>\n<html><head><link href="' + cssUrl + '" rel="stylesheet" type="text/css">' +
            '<link rel="stylesheet" href="https://use.typekit.net/clk6sif.css">' +
            '<meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no">' +
            '</head><body><div class="loading" data-role="loading"><div class="loader"></div></div>' +
            '<div id="app" data-ui="app-container">' +
            '<a data-template="app" data-selector="#app" data-publish="app-loaded" data-auto-load></a></div>' +
            '<script src="' + jsUrl + '" defer></script></body></html>';

        iframeNew.setAttribute('data-ycs', 'customizer');
        iframeNew.setAttribute('title', 'YETI Customizer');
        // Write document layout
        iframeNew.srcdoc = html;
        // Prepend the iframe to the target selector
        target.prepend(iframeNew);
        Object.assign(iframeNew.style, {
            position: 'fixed',
            left: 0,
            top: 0,
            bottom: 0,
            zIndex: 2147483646,
            height: '100%',
            minHeight: 'auto',
            maxHeight: '100vh',
            overflowY: 'hidden',
            width: '100%',
            maxWidth: '100vw',
            padding: 0,
            margin: 0,
            border: 'none',
            display: 'none'
        });

        return true;
    };

}

/**
 * Attach YETI to the browser's `window` namespace
 */
if (window.YETI === undefined) {
    window.YETI = YETI;
}
window.YETI.customizer = new customizer();